<template>
	<div>
		<van-image width="100%" fit="cover" :src="require('@/assets/image/day.jpg')" />
		<div class="q_pad_lr15px q_mar_day">
			<van-tabs v-model="dayactive" type="card"  @click="onClick">

				<van-tab title="待参加" name="1">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
            <van-list
                v-model:loading="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="JoinSunActivityOnLoad"
                error-text="请求失败，点击重新加载"
            >
					<van-steps direction="vertical" :active="-1">
						<van-step v-for="item in JoinSunActivity" :key="item.id">
							<div @click="goToActivdea(item.id)">
								<p class="q_text_s q_color_gray q_mar_b10px">{{item.activityStartTime}} ~ {{item.activityEndTime}}</p>
								<p class="q_text_m q_color_black q_mar_b5px">{{item.name}}</p>
								<p class="q_text_s q_color_gray">{{item.address}}</p>
							</div>
						</van-step>
					</van-steps>
            </van-list>
          </van-pull-refresh>
          <!--空数据-->
          <div class="q_center" style="margin-top: 10vh;margin-bottom: 10vh;" v-if="JoinSunActivity.length=='0'">
            <img src="@/assets/image/none.png" style="width: 26vw;"/>
            <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
          </div>
				</van-tab>


				<van-tab title="待审核" name="2">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
            <van-list
                v-model:loading="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="CheckSunActivityOnLoad"
                error-text="请求失败，点击重新加载"
            >
          <van-steps direction="vertical" :active="-1">
            <van-step v-for="item in checkSunList" :key="item.id">
              <div @click="goToActivdea(item.id)">
                <p class="q_text_s q_color_gray q_mar_b10px">{{item.activityStartTime}} ~ {{item.activityEndTime}}</p>
                <p class="q_text_m q_color_black q_mar_b5px">{{item.name}}</p>
                <p class="q_text_s q_color_gray">{{item.address}}</p>
              </div>
            </van-step>
          </van-steps>
            </van-list>
          </van-pull-refresh>
          <!--空数据-->
          <div class="q_center" style="margin-top: 10vh;margin-bottom: 10vh;" v-if="checkSunList.length=='0'">
            <img src="@/assets/image/none.png" style="width: 26vw;"/>
            <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
          </div>
				</van-tab>

			</van-tabs>
		</div>
	</div>
</template>

<script>
import {listCheckSunActivity, listJoinSunActivity} from "@/api/activity";
import {wxCloseShare} from "@/utils/jiutang";

export default {
		name: 'Actiday',
		props: {
			msg: String
		},
		data() {
			return {
        showEmpty: false,
        refreshing: false,
        loading: false,
        finished: false,
				dayactive: 0,
        checkSunList:[],
        JoinSunActivity:[],
        pageParam: {
          pageNum: 0,
          pageSize: 6,
        },
        name:1
			}
		},
  created() {
    wxCloseShare()
  },
  methods: {
      /**
       * 下拉刷新
       */
      onRefresh() {
        this.pageParam.pageNum = 0
        this.pageParam.pageSize = 6
        // 清空列表数据
        this.finished = false
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true
        //this.onLoad()
        if (this.name == '1') {
          this.JoinSunActivity = []
          this.JoinSunActivityOnLoad()
        }
        if (this.name == '2') {
          this.checkSunList = []
          this.CheckSunActivityOnLoad()
        }
      },
      /**
       * 待参加动态下滑加载更多
       */
      JoinSunActivityOnLoad() {
        this.pageParam.pageNum++
        if (this.pageParam.pageNum == 1) {
          this.$modal.loading()
        }
        //查询待参加信息列表
        listJoinSunActivity(this.pageParam).then(res => {
          if (res.total == 0) {
            this.showEmpty = true
          }else{
            this.showEmpty = false
          }
          //是否下拉刷新
          if (this.refreshing) {
            this.JoinSunActivity = [];
            this.refreshing = false;
          }
          console.log('res', res)
          for (let i = 0; i < res.rows.length; i++) {
            this.JoinSunActivity.push(res.rows[i]);
          }

          // 加载状态结束
          this.loading = false;

          // 数据全部加载完成
          if (this.JoinSunActivity.length >= res.total) {
            this.finished = true;
          }
        }).finally(() => {
          this.$modal.closeLoading()
        })
      },
      /**
       * 待审核动态下滑加载更多
       */
      CheckSunActivityOnLoad() {
        this.pageParam.pageNum++
        if (this.pageParam.pageNum == 1) {
          this.$modal.loading()
        }
        //查询待审核信息列表
        listCheckSunActivity(this.pageParam).then(res => {
          if (res.total == 0) {
            this.showEmpty = true
          }else{
            this.showEmpty = false
          }
          //是否下拉刷新
          if (this.refreshing) {
            this.checkSunList = [];
            this.refreshing = false;
          }
          for (let i = 0; i < res.rows.length; i++) {
            this.checkSunList.push(res.rows[i]);
          }

          // 加载状态结束
          this.loading = false;

          // 数据全部加载完成
          if (this.checkSunList.length >= res.total) {
            this.finished = true;
          }
        }).finally(() => {
          this.$modal.closeLoading()
        })
      },
      onClick(name, title) {
        //每次点击清空列表，重置查询条件
        this.pageParam.pageNum = 0
        this.pageParam.pageSize = 6
        this.JoinSunActivity = []
        this.checkSunList = []
        if (name == 1) {
          this.name = name
          this.JoinSunActivityOnLoad()
        }
        if (name == 2) {
          this.name = name
          this.CheckSunActivityOnLoad()
        }
      },
			goToActivdea(id) {
				this.$router.push({
					path: '/activity/Activdea',query:{id:id}
				});
			},
		}
	}
</script>
<style scoped="scoped">
	.q_mar_day {
		margin-top: -40px;
	}

	.q_mar_day>>>.van-tabs__nav--card,
	.q_mar_day>>>.van-tabs--card>.van-tabs__wrap {
		height: 80px;
	}

	.q_mar_day>>>.van-tabs__nav--card {
		margin: 10px 80px 0 80px;
		height: 60px;
		border: none;
		border-radius: 30px;
		box-shadow: 0 0 10px #f2f3f7;
	}

	.q_mar_day>>>.van-tabs__nav--card .van-tab {
		color: #333333;
		font-size: 14px;
		line-height: 60px;
		border: none;
	}

	.q_mar_day>>>.van-tabs__nav--card .van-tab.van-tab--active {
		background-color: rgba(0, 0, 0, 0);
		border-radius: 30px;
		color: #FF5733;
		border: none;
		font-weight: 700;
	}

	>>>.van-step__circle {
		width: 15px;
		height: 15px;
		background-color: #FF5733;
		box-shadow: 0 0 4px #ff5733;
		position: relative;
	}

	>>>.van-step--vertical:nth-child(2n) .van-step__circle {
		background-color: #FFC300;
		box-shadow: 0 0 4px #FFC300;
	}

	>>>.van-step__circle::after {
		content: "";
		position: absolute;
		top: 5px;
		left: 5px;
		width: 5px;
		height: 5px;
		background-color: #ffffff;
		border-radius: 50%;
	}
</style>
